import React from "react";
import { Link } from "react-router-dom";
import { FAQ } from "../mock";
import { Reveal, PageHero, Ornament } from "../components/bits";
import VideoBackground from "../components/VideoBackground";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FaqPage = () => {
  const { hero, items, cta } = FAQ;

  return (
    <main className="video-page">
      <PageHero title={hero.title} sub={hero.sub} align="center" light />
      <VideoBackground veil={0.5} />

      <section className="section bloom">
        <div className="container-page">
          <Reveal className="faq-wrap">
            <Accordion type="single" collapsible className="w-full">
              {items.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-[color:var(--line)]"
                >
                  <AccordionTrigger className="text-left py-6 hover:no-underline">
                    <span
                      style={{
                        fontFamily: "var(--font-serif)",
                        fontSize: "clamp(1.15rem, 2vw, 1.4rem)",
                        color: "var(--ink)",
                        fontWeight: 500,
                        paddingRight: "1rem",
                      }}
                    >
                      {item.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent>
                    <p
                      style={{
                        color: "var(--ink-soft)",
                        fontSize: "1.02rem",
                        lineHeight: 1.85,
                        paddingBottom: "0.5rem",
                      }}
                    >
                      {item.a}
                    </p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      {/* CTA */}
      <section className="section-tight" style={{ background: "var(--paper-warm)" }}>
        <div className="container-page">
          <Reveal className="container-narrow" style={{ textAlign: "center" }}>
            <Ornament style={{ marginBottom: "1.25rem", justifyContent: "center", display: "inline-flex" }} />
            <h2 className="h-section">From Understanding to Abiding</h2>
            <p className="lead" style={{ marginTop: "1.25rem" }}>
              {cta.body}
            </p>
            <Link to="/contacts" className="btn-gold" style={{ marginTop: "2rem" }}>
              {cta.label}
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default FaqPage;
